<div class="card-structure grid grid-cols-1 md:grid-cols-2 gap-4 bg-white rounded-xl p-4 items-top">
  <!-- Infos principales -->
  <div class="flex flex-col gap-2">
    <h5 class="!font-medium text-gray-600">
      {{ structure.name }}
    </h5>

    <!-- Prestataire Connecté indicator -->
    @if (structure.eyoneUser) {
    <div class="flex items-center gap-1"
      [title]="'Ce prestataire échange automatiquement vos informations avec votre {{getProductName()}} pour faciliter votre prise en charge.'">
      <span class="bg-green-100 text-green-700 text-xs font-semibold px-2 py-1 rounded flex items-center gap-1">
        <lucide-icon [img]="CircleIcon" [size]="10" class="fill-green-500 text-green-500"></lucide-icon>
        Prestataire Connecté
      </span>
    </div>
    }

    <div class="text-primary uppercase text-sm font-medium" *ngIf="structure.structureType?.name">
      {{ structure.structureType?.name }}
    </div>

    <!-- Specialisations list -->
    @if (structure.specialisations?.length) {
    <div class="flex flex-wrap gap-2 mt-1">
      @for (spec of structure.specialisations.slice(0, 3); track $index) {
      <span class="bg-gray-200 text-gray-700 text-xs font-semibold px-2 py-1 rounded">
        {{ spec.name }}
      </span>
      }
    </div>
    }

    <!-- <div class="text-gray-600 text-sm" *ngIf="structure.coordonate?.globalAddressField">{{
			structure.coordonate?.globalAddressField }}</div> -->
    @if (structure?.coordonate?.globalAddressField) {
    <div>
      <p class="text-gray-600 text-sm">
        {{ structure.coordonate.globalAddressField }}
      </p>
      @if (structure?.distance != null) {
      <span class="flex items-center gap-x-1 text-xs text-gray-400 mt-1">
        <lucide-icon class="text-primary" [img]="MapPinIcon" [size]="14"></lucide-icon>
        <span class="text-primary">{{
          roundDistance(structure.distance)
          }}</span>
      </span>
      }
    </div>
    }

    <button [routerLink]="[PrefixUrlCountryCode, 'structures', structure.id]"
      class="btn btn-sm w-fit bg-[#232c7c] text-white rounded-full text-sm hover:bg-[#232c7c]-dark transition-colors">
      <span class="flex items-center gap-x-2"> Voir les détails </span>
    </button>
  </div>
  <!-- Carte Google Maps -->
  <div class="rounded-lg overflow-hidden w-full h-40 min-h-[160px]">
    <app-safe-maps [latitude]="structure.coordonate?.latitude ?? 0" [longitude]="structure.coordonate?.longitude ?? 0"
      [zoom]="15" height="100%">
    </app-safe-maps>
  </div>
</div>